import React from 'react';

const cultureData = [
  {
    title: 'Farmer-First Mindset',
    description:
      "We exist for the farmer. Every feature, update, and partnership is driven by the goal of making life easier, more productive, and more profitable for smallholder farmers. We listen, learn, and adapt based on real needs in the field.\n\n“If it doesn’t help the farmer, we don’t build it.”",
    image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744978069/image_vhpwvc.png',
  },
  {
    title: 'Accessibility & Inclusion',
    description:
      "We believe in tech for all, not just the digitally connected. Whether a farmer uses a smartphone or a basic feature phone, speaks English or a local language, lives in a city or a remote village — we build tools that include, not exclude.\n\n“No farmer left behind.”",
    image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744978069/image-1_w6no6o.png',
  },
  {
    title: 'Trust & Transparency',
    description:
      "We strive to be a reliable partner to farmers, governments, and organizations. Information shared through our platform is accurate, clear, and respectful of user privacy. Our communication is always honest and empowering.\n\n“Trust is our most valuable crop.”",
    image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744978069/image-2_sqyowj.png',
  },
  {
    title: 'Community Empowerment',
    description:
      "We foster networks of collaboration, shared learning, and mutual support. Farmers thrive when they connect—with each other, with experts, and with markets. We are building more than an app; we’re building a movement of farmers helping farmers.\n\n“Together, we grow stronger.”",
    image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744978069/image-3_wejelr.png',
  },
  {
    title: 'Innovation with Purpose',
    description:
      "We’re tech-driven, but we innovate with purpose and practicality. Whether it’s AI-powered crop diagnostics or a simple USSD menu, we use technology to solve real problems in the most user-friendly way.\n\n“Smart tech, simple tools, real results.”",
    image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744978069/image-4_i7ggx0.png',
  },
  {
    title: 'Resilience & Sustainability',
    description:
      "We champion climate-smart, sustainable agriculture. Our app supports practices that protect land, water, and biodiversity while increasing yield and income. We are part of the solution to climate challenges facing rural communities.\n\n“Resilience is our strategy. Sustainability is our legacy.”",
    image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744978069/image-5_swndhf.png',
  },
 
];

const OurCultureSection = () => {
  return (
    <div className="bg-[#142B24] py-5 max-w-7xl mx-auto">
      <div className="grid grid-cols-2 md:grid-cols-2 gap-8 ">
        {cultureData.map((item, index) => (
          <div key={index} className="">
            <img
              src={item.image}
              alt="icon"
              className="md:w-[76px] md:h-[76px] w-[25px] h-[25px] flex-shrink-0 mb-1"
            />
            <div>
              <h3 className="md:text-[32px] text-white text-[10px] font-bold mb-2">{item.title}</h3>
              <p className="text-white text-[6px] md:text-[20px] whitespace-pre-line">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurCultureSection;
